module.exports = __webpack_public_path__ + "static/img/champion.66a3906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/champion.png
// module id = oS25
// module chunks = 1